import { Component } from '@angular/core';

@Component({
    selector: 'masthead-homepage',
    templateUrl: './masthead-homepage.component.html',
    standalone: false
})
export class MastheadHomepageComponent {

  constructor() { }

}
